function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m426.410156 150.757812c-40.667968-.933593-72.894531-34.640624-72-75.3125.035156-31.410156 18.976563-59.714843 48-71.726562-10.039062-2.769531-20.445312-3.980469-30.855468-3.585938-54.917969 0-99.433594 46.5625-99.433594 104 0 57.441407 44.515625 104 99.433594 104 42.414062-.089843 79.875-27.664062 92.566406-68.132812-11.148438 7.40625-24.328125 11.167969-37.710938 10.757812zm0 0",
  fill: "#fce666"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m363.15625 336.132812c30.167969.726563 58.359375-14.953124 73.660156-40.964843 15.296875-26.015625 15.296875-58.277344 0-84.289063-15.300781-26.011718-43.492187-41.691406-73.660156-40.96875-5.640625.003906-11.269531.554688-16.800781 1.648438-6.925781-32.023438-35.375-54.792969-68.136719-54.535156-10.015625.003906-19.917969 2.144531-29.039062 6.277343-16.066407-41.285156-59.042969-65.496093-102.679688-57.839843-43.636719 7.652343-75.804688 45.046874-76.855469 89.335937.019531 10.351563 1.855469 20.621094 5.421875 30.335937-27.144531.160157-52.113281 14.878907-65.402344 38.550782-13.285156 23.671875-12.847656 52.652344 1.15625 75.910156 14 23.253906 39.40625 37.207031 66.542969 36.539062",
  fill: "#a3d4f7"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#60a2d7"
}, /*#__PURE__*/React.createElement("path", {
  d: "m328.121094 368.132812c0 17.675782-14.324219 32-32 32-17.671875 0-32-14.324218-32-32 0-24 32-80 32-80s32 56 32 80zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m248.121094 288.132812c0 17.675782-14.324219 32-32 32-17.671875 0-32-14.324218-32-32 0-24 32-80 32-80s32 56 32 80zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m176.121094 384.132812c0 17.675782-14.324219 32-32 32-17.671875 0-32-14.324218-32-32 0-24 32-80 32-80s32 56 32 80zm0 0"
}));

var SvgRainyNight = function SvgRainyNight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "0 -24 464.12294 464",
    width: "464pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRainyNight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rainy-night.d23b18ea.svg";
export { ForwardRef as ReactComponent };